import {getCacheConfig}from'@mongez/cache';import events from'@mongez/events';import {Random,merge,set}from'@mongez/reinforcements';import {isFormElement,isFormData,isPlainObject}from'@mongez/supportive-is';import axios,{Axios}from'axios';/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-async-promise-executor */
class Endpoint extends Axios {
    configurations;
    /**
     * Last request controller
     */
    lastRequest;
    /**
     * Default configurations
     */
    defaultConfigurations = {
        putToPost: false,
        cache: false,
        cacheOptions: {
            ttl: 5 * 60, // 5 minutes
        },
        putMethodKey: '_method',
        ...axios.defaults,
    };
    /**
     * Endpoint id
     */
    endpointId = Random.id();
    /**
     * Endpoint event namespace
     */
    eventNamespace = `endpoint.${this.endpointId}`;
    /**
     * Constructor
     */
    constructor(configurations = {}) {
        super(configurations);
        this.configurations = configurations;
        this.defaults = merge(this.defaultConfigurations, configurations);
        this.configurations = merge(this.defaultConfigurations, configurations);
        this.boot();
    }
    /**
     * Set endpoint configurations
     */
    setConfigurations(configurations) {
        this.configurations = merge(this.configurations, configurations);
        this.defaults = this.configurations;
    }
    /**
     * Boot the endpoint
     */
    boot() {
        this.addInterceptors();
    }
    /**
     * Add axios interceptors
     */
    addInterceptors() {
        this.addRequestInterceptors();
        this.addResponseInterceptors();
    }
    /**
     * Add request interceptors
     */
    addRequestInterceptors() {
        this.interceptors.request.use((requestConfig) => {
            // A workaround for put requests to be sent as post request
            // this will allow us to upload images
            const headers = requestConfig.headers || {};
            const isPutRequest = requestConfig.method?.toUpperCase() === 'PUT';
            let data = requestConfig.data;
            if (isFormElement(data)) {
                data = new FormData(data);
            }
            if (isPutRequest && this.configurations.putToPost) {
                requestConfig.method = 'POST';
                if (isFormData(data)) {
                    data.append(this.configurations.putMethodKey, 'PUT');
                }
                else if (isPlainObject(data) && this.configurations.putMethodKey) {
                    data = set(data, this.configurations.putMethodKey, 'PUT');
                }
            }
            if (isPlainObject(data)) {
                headers['Content-Type'] = 'Application/json';
                data = JSON.stringify(data);
            }
            requestConfig.data = data;
            const authHeader = this.configurations.setAuthorizationHeader;
            if (authHeader && !headers?.Authorization) {
                if (typeof authHeader === 'function') {
                    const authorizationValue = authHeader(requestConfig);
                    if (authorizationValue) {
                        headers.Authorization = authorizationValue;
                    }
                }
                else {
                    headers.Authorization = authHeader;
                }
            }
            requestConfig.headers = headers;
            if (!requestConfig.signal) {
                this.lastRequest = new AbortController();
                requestConfig.signal = this.lastRequest.signal;
            }
            // trigger event of sending ajax request
            this.trigger('sending', requestConfig);
            return requestConfig;
        });
    }
    /**
     * Add response interceptors
     */
    addResponseInterceptors() {
        this.interceptors.response.use((response) => {
            if (response.config.signal === this.lastRequest?.signal) {
                this.lastRequest = undefined;
            }
            this.trigger('complete', response);
            this.trigger('success', response);
            return response;
        }, (error) => {
            if (error.response?.config?.signal === this.lastRequest?.signal) {
                this.lastRequest = undefined;
            }
            this.trigger('complete', error.response);
            this.trigger('error', error.response);
            return Promise.reject(error);
        });
    }
    /**
     * {@inheritDoc}
     */
    get(url, options) {
        const request = new Promise(async (resolve, reject) => {
            const isCacheable = options?.cache || (this.configurations.cache && options?.cache !== false);
            if (isCacheable) {
                const cacheConfigurations = {
                    ...(this.configurations.cacheOptions || {}),
                    ...(options?.cacheOptions || {}),
                };
                const cacheDriver = cacheConfigurations.driver;
                if (!cacheConfigurations.key) {
                    cacheConfigurations.key =
                        this.configurations.cacheOptions?.generateKey?.(url, options?.params) ||
                            this.getCacheKey(url, options?.params);
                }
                const cacheKey = cacheConfigurations.key;
                const response = await cacheDriver?.get(cacheKey);
                const expiresAfter = cacheConfigurations.ttl ?? cacheConfigurations.expiresAfter;
                const expireTime = expiresAfter !== undefined
                    ? expiresAfter
                    : (getCacheConfig('expiresAfter') || 0);
                const expiresAt = expireTime ? new Date().getTime() + expireTime * 1000 : undefined;
                console.log({ expiresAt });
                if (response) {
                    resolve(response);
                }
                else {
                    super
                        .get(url, options)
                        .then((response) => {
                        if (isCacheable && cacheDriver) {
                            cacheDriver.set(cacheKey, {
                                data: response.data,
                                status: response.status,
                                statusText: response.statusText,
                                headers: response.headers,
                            }, cacheConfigurations.ttl ?? cacheConfigurations.expiresAfter);
                        }
                        resolve(response);
                    })
                        .catch((error) => reject(error));
                }
            }
            else {
                super
                    .get(url, options)
                    .then(resolve)
                    .catch(reject);
            }
        });
        return request;
    }
    /**
     * Get endpoint last request
     */
    getLastRequest() {
        return this.lastRequest;
    }
    /**
     * Get events subscribers
     */
    get events() {
        return {
            /**
             * Triggered when response is returned with error response
             */
            onError: (callback) => {
                return events.subscribe(`${this.eventNamespace}.error`, callback);
            },
            /**
             * Triggered when response is returned with success response
             */
            onSuccess: (callback) => {
                return events.subscribe(`${this.eventNamespace}.success`, callback);
            },
            /**
             * Triggered when response is returned wether it is success or error response
             */
            onComplete: (callback) => {
                return events.subscribe(`${this.eventNamespace}.complete`, callback);
            },
            /**
             * Triggered before sending response
             */
            beforeSending: (callback) => {
                return events.subscribe(`${this.eventNamespace}.sending`, callback);
            },
        };
    }
    /**
     * Trigger the given event
     */
    trigger(event, ...args) {
        return events.trigger(`${this.eventNamespace}.${event}`, ...args);
    }
    /**
     * Get cache key form the given path
     */
    getCacheKey(path, params) {
        const key = `endpoint.${this.configurations.baseURL}.${path}`;
        if (params) {
            return `${key}.${JSON.stringify(params)}`;
        }
        return key;
    }
    /**
     * Get configurations list
     */
    getConfigurations() {
        return this.configurations;
    }
    /**
     * Get config for the given key
     */
    getConfig(key, defaultValue) {
        return this.configurations[key] ?? defaultValue;
    }
}export{Endpoint};